import {Inject, Injectable} from "@angular/core";
import {SignalrService} from "./signal-r.service";
import {HubConnection} from "@microsoft/signalr";
import { HttpClient } from "@angular/common/http";
import {NgxFileSaverService} from "@clemox/ngx-file-saver";
import {LoginServerService} from "src/app/layouts/public/login/services/login-server.service";
import {StepPercent} from "../components/progress-banner/models/StepPercent";
import { isNullOrUndefined } from 'src/app/helpers/tools';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {catchError} from "rxjs/internal/operators/catchError";
import {throwError} from "rxjs/internal/observable/throwError";

@Injectable({
    providedIn: 'root'
})
export class ProgressBannerService {

    private _signalRDataSyncHub: SignalrService;
    private _hubConnection: HubConnection | undefined;
    public isMinimized: boolean = false;
    public success: boolean = false;
    public inProgress: boolean = false;
    public isTerminated: boolean = false;
    public percentage: number = 0;
    public timer: number = null;
    public successMessage: string = "";
    public progressMessage: string = "";
    public warningMessage: string = "";
    public terminatedMessage: string = "Process cancelled.";
    public currentFileType: string = "";
    
    constructor(public _http: HttpClient, @Inject('BASE_URL') public baseUrl: string, private _fileSaver: NgxFileSaverService, private loginService: LoginServerService) {

    }

    public setup() {
        this._signalRDataSyncHub = new SignalrService(this.baseUrl);

        this.signalRServiceStart();

        this.loginService.currentAccountChangedNotify.subscribe(() => {
            // As the autnetication is used in the progress hub rconnect when the user changes
            if (this._signalRDataSyncHub) {
                this._signalRDataSyncHub.reconnect();
            }
        });
    }

    private async signalRServiceStart() {
        if (!this._hubConnection || !this._signalRDataSyncHub) {
            await this._signalRDataSyncHub.CreateConnnectionWithReconnectWithClose('/hubs/progress', (connection) => this.dataSyncHandlers(connection), (connection) => this.dataSyncConnected(connection), connection => this.setDataSyncHubConnection(connection), () => this.onDataSyncConnectionClosed());
        }
    }
    
    public sendMessage(msg, data = null) {
        if (data) {
            this._hubConnection.send(msg, data, this._hubConnection.connectionId);
        } else {
            this._hubConnection.send(msg, this._hubConnection.connectionId);
        }
    }
    
    public startExport(data) {
        this.success = false;
        this.isTerminated = false;
        this.timer = null;
        this.isMinimized = false;
        this.sendMessage("ExportResults", data);
    }

    public signalRServiceKill() {
        this._signalRDataSyncHub.disconnect();
    }

    private setDataSyncHubConnection(connection: HubConnection) {
        this._hubConnection = connection;
    }

    private onDataSyncConnectionClosed() {

    }

    private async dataSyncHandlers(connection: HubConnection) {
        connection.on('progressUpdate', async (data: StepPercent) => {
            this.percentage = data.percent;
            this.inProgress = true;
            this.updateprogressbar(this.percentage);
            this.currentFileType = data.format;
                      
            if (this.percentage == 100 && data.body) {
                var bytes = new Uint8Array(atob(data.body).split('').map(char => char.charCodeAt(0)));

                var downloadedFile = new Blob([bytes], { type: data.contentType });
                this._fileSaver.saveBlob(downloadedFile, `result-export.${data.format}`);
            
                this.inProgress = false;
                this.success = true;
                this.currentFileType = "";
                this.setTimer();
            } else if (data.isTerminated) {
                this.inProgress = false;
                this.success = false;
                this.currentFileType = "";
                this.isTerminated = true;
                this.setTimer();
            }
        });
    }

    private dataSyncConnected(connection: HubConnection) {
        
    }

    updateprogressbar(value: number) {
        this.inProgress = true;
        $('#divUploadprogressBarfg').text(Math.round(value) + '%');
        $('#divUploadprogressBarfg').css('width', Math.round(value) + '%');
        $('#divUploadprogressBarfg').css('aria-valuenow', Math.round(value));
    }

    public minimize() {
        if (this.inProgress) {
            this.isMinimized = true;
        } else {
            this.isMinimized = false;
        }
    }

    public maximize() {
        this.isMinimized = false;
    }
    
    public setTimer() {
        if (!isNullOrUndefined(this.timer)) {
            window.clearTimeout(this.timer);
        }

        this.timer = window.setTimeout(() => {
            this.timer = null;
            this.success = false;
            this.inProgress = false;
            this.isTerminated = false;
        }, 15000); // 15000 millisecond means 15 seconds
    }

    public async cancelProcess() {
        await firstValueFrom(this._http.get(`${this.baseUrl}api/ExportProgress/Terminate?connectionID=${this._hubConnection.connectionId}`)
            .pipe(catchError(this.handleError)));
    }
    
    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}
